import React, { useEffect, useState } from 'react';

const Sitemap = ({ blogList }) => {
  const [sitemapXML, setSitemapXML] = useState('');
  const today = new Date(); // fixed date
  const formattedDate = today.toISOString().split("T")[0];

  // Generate sitemap
  function generateSitemap() {
    const urls = [
      { loc: "https://mybuilderid.com/", lastmod: formattedDate, changefreq: "daily", priority: "1.00" },
      { loc: "https://mybuilderid.com/about", lastmod: formattedDate, changefreq: "monthly", priority: "0.80" },
      { loc: "https://mybuilderid.com/blog", lastmod: formattedDate, changefreq: "weekly", priority: "0.80" },
      { loc: "https://mybuilderid.com/contact", lastmod: formattedDate, changefreq: "monthly", priority: "0.60" },
      { loc: "https://mybuilderid.com/features", lastmod: formattedDate, changefreq: "monthly", priority: "0.70" },
      { loc: "https://mybuilderid.com/faq", lastmod: formattedDate, changefreq: "monthly", priority: "0.70" },
      ...(blogList?.map(blog => ({
        loc: `https://mybuilderid.com/${blog.slug}`,
        lastmod: blog.updatedAt || formattedDate,
        changefreq: "monthly",
        priority: "0.60",
      })) || [])
    ];

    const urlset = urls.map(url => `
      <url>
        <loc>${url.loc}</loc>
        <lastmod>${url.lastmod}</lastmod>
        <changefreq>${url?.changefreq}</changefreq>
        <priority>${url.priority}</priority>
      </url>
    `).join("");

    return `<?xml version="1.0" encoding="UTF-8"?>
      <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
        ${urlset}
      </urlset>`;
  }

  // Generate and set sitemap XML when blogList updates
  useEffect(() => {
    if (blogList) {
      setSitemapXML(generateSitemap());
    }
  }, [blogList]);

  return (sitemapXML)
}

export default Sitemap;
